import {
  spacing1,
  spacing10,
  spacing12,
  spacing2,
  spacing3,
  spacing4,
  spacing5,
  spacing6,
  spacing7,
  spacing8,
  spacing9,
} from 'lib/mortar';
import styled, { css } from 'styled-components';

const cssflexDirection =
  (defaultDirection?: 'row' | 'column') =>
  ({ direction = defaultDirection }: { direction?: 'row' | 'column' }) =>
    direction &&
    css`
      flex-direction: ${direction};
    `;

const cssJustifyContent = ({
  justifyContent,
}: {
  justifyContent?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around';
}) =>
  justifyContent &&
  css`
    justify-content: ${justifyContent};
  `;

const cssAlignItems = ({
  alignItems,
}: {
  alignItems?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around';
}) =>
  alignItems &&
  css`
    align-items: ${alignItems};
  `;

const spacing = {
  1: spacing1,
  2: spacing2,
  3: spacing3,
  4: spacing4,
  5: spacing5,
  6: spacing6,
  7: spacing7,
  8: spacing8,
  9: spacing9,
  10: spacing10,
  12: spacing12,
} as const;

type Spacing = keyof typeof spacing;

const cssGap = ({ gap }: { gap?: Spacing }) =>
  gap &&
  css`
    gap: ${spacing[gap]};
  `;

export const Stack = styled.div<
  StyledDiv & {
    direction?: 'row' | 'column';
    justifyContent?:
      | 'flex-start'
      | 'center'
      | 'flex-end'
      | 'space-between'
      | 'space-around';
    alignItems?:
      | 'flex-start'
      | 'center'
      | 'flex-end'
      | 'space-between'
      | 'space-around';
    gap?: Spacing;
  }
>`
  display: flex;
  box-sizing: border-box;
  ${cssflexDirection('column')}
  ${cssJustifyContent}
  ${cssAlignItems}
  ${cssGap}
`;
